export default "<spec-app-type11-file-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type11-file-table>\n";